module.exports = __webpack_public_path__ + "media/companies/Meanings-204969d5.png";